
import { getPurchaseOrderStatusConfig } from "./PurchaseOrderList/config";
import getHexColor from "utils/getHexColor";

/**
 * Returns the display config (label, bgColor, textColor) for a given PO status string.
 *
 * @param {string} poStatus - The resolved status string to look up.
 * @returns {{ label: string, bgColor: string, textColor: string }}
 */
export function getPoStatusDisplayConfig(poStatus) {
  const statusConfig = getPurchaseOrderStatusConfig(poStatus);
  const colorType = statusConfig?.color || "grey";
  const bgColor = getHexColor({ type: colorType, tint: 100 });
  const textColor = getHexColor({ type: colorType, tint: 600 });

  return { label: statusConfig.label, bgColor, textColor };
}
